import { getUserToken } from "../helpers/authHelper";
import api from "../api";


export async function FetchConsentList() {

  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/consent/getconsentData`,
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
  });
}

export async function FetchDataDeletionRequestList() {

  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/consent/getdeletionrequestData`,
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
  });
}

export async function DeleteAccountRecord(id) {
  return await api({
    method: "get",
    data: '',
    url: `${process.env.REACT_APP_API_URL}/admin/consent/deleteaccount/${id}`,
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
  });
 }